import Swiper from 'swiper/bundle';

const rsCarousel = {
    init: (carousels) => {
        const windowWidth = jQuery(window).width();
        carousels.forEach(carousel => {
            const swiperOptions = {};
            const loop = carousel.dataset.loop;
            const autoplay = carousel.dataset.autoplay;
            const pagination = carousel.dataset.pagination;
            const slidesper = carousel.dataset.slidesper;
            const effect = carousel.dataset.effect;
            // const navigation = carousel.dataset.navigation;

            if (windowWidth >= 1024) {
                swiperOptions.allowTouchMove = false;
            }

            if (slidesper) {
                swiperOptions.centeredSlides = true;
                const perView = carousel.dataset.slidesperdesktop;
                const perViewMobile = carousel.dataset.slidespermobile;
                const perViewTablet = carousel.dataset.slidespertablet;

                swiperOptions.slidesPerView = perViewMobile || 1;

                if (perViewMobile && perViewTablet) {
                    swiperOptions.breakpoints = {
                        576: {
                            slidesPerView: perViewTablet,
                        },
                        960: {
                            slidesPerView: perView,
                        },
                    };
                }
            } else {
                swiperOptions.effect = 'fade';
                swiperOptions.slidesPerView = 1;
            }

            if (loop) {
                swiperOptions.loop = true;
            }

            if (autoplay) {
                swiperOptions.autoplay = {
                    delay: autoplay,
                    disableOnInteraction: false,
                    pauseOnMouseEnter: true,
                };
            }

            if (pagination) {
                swiperOptions.pagination = {
                    el: '.swiper-pagination',
                    clickable: true,
                };
            }

            if (effect) {
                swiperOptions.effect = 'fade';
            }

            // eslint-disable-next-line no-unused-vars
            const swiper = new Swiper(`#${carousel.getAttribute('id')}`, swiperOptions);

            if (!slidesper) {
                const activeCount = document.querySelector(`#${carousel.id} .swiper-slide-count__active`);
                const totalCount = document.querySelector(`#${carousel.id} .swiper-slide-count__total`);

                const generateSlideCounter = (active, total) => {
                    const slides = Array.from(document.querySelectorAll(`#${carousel.id} .swiper-slide`));
                    const slidesCount = [];

                    slides.forEach((slide) => {
                        if (!slide.classList.contains('swiper-slide-duplicate')) {
                            slidesCount.push(slide);
                        }
                    });
                };

                generateSlideCounter(activeCount, totalCount);
            }
        });
    },
};

export default rsCarousel;
